import { useEffect } from 'react';
import PropTypes from 'react-proptypes';
import { connect } from 'react-redux';
import {
  CheckboxComponent,
  IncomeInputComponent,
  MessageBoxComponent,
} from '@dnhb/node_package';
import { dispatchMapper } from '../../../shared/wizard/actions';
import Analytics from 'shared/utility/analytics';
import { shapeInput, shapeOutput } from '../config';
import { useLocation, useNavigate } from 'react-router-dom';

const WizardIncome = ({ input, sync, output, forward, recalculating }) => {
  const { errors } = output;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    Analytics.send('Navigeer', 'Inkomen formulier');
  }, []);

  const mijnOverheidLink = (
    <a href="https://mijnpensioenoverzicht.nl" rel="noopener noreferrer" target="_blank">
      mijnpensioenoverzicht.nl
    </a>
  );

  return (
    <form onSubmit={forward(recalculating, location, navigate)}>
      <input type="submit" className="hidden" />
      <div className="wrapper">
        <h2>Uw inkomen</h2>
        {
          output.applicant_show_income ? (
            <div>
              <h3>Uw bruto inkomen</h3>
              <div className="row">
                <div className="group col-xs-12">
                  <IncomeInputComponent
                    id="applicant_income"
                    onAmountChangeHandler={sync('applicant_income')}
                    onPeriodChangeHandler={sync('applicant_income_period')}
                    amount={input.applicant_income}
                    period={input.applicant_income_period}
                    errors={errors.applicant_income}
                    label="Bedrag"
                  />
                </div>
              </div>
              { input.applicant_income_period === 'monthly' ?
                <div className="row">
                  <div className="group col-sm-6 col-xs-12">
                    <CheckboxComponent
                      id="applicant_holiday_bonus"
                      onChangeHandler={sync('applicant_holiday_bonus')}
                      value={input.applicant_holiday_bonus}
                      label="Vakantiegeld?"
                    />
                  </div>
                  <div className="group col-sm-6 col-xs-12">
                    <CheckboxComponent
                      id="applicant_13th_month_salary"
                      onChangeHandler={sync('applicant_13th_month_salary')}
                      value={input.applicant_13th_month_salary}
                      label="13e maand?"
                    />
                  </div>
                </div> : null
              }
            </div>
          ) : null
        }
        {
          output.applicant_show_aow ? (
            <div>
              <h3>Uw pensioeninkomen</h3>
              <div className="row">
                <div className="group col-xs-12">
                  <IncomeInputComponent
                    id="applicant_pension_income"
                    onAmountChangeHandler={sync('applicant_pension_income')}
                    onPeriodChangeHandler={sync('applicant_pension_income_period')}
                    amount={input.applicant_pension_income}
                    period={input.applicant_pension_income_period}
                    errors={errors.applicant_pension_income}
                    label="Bedrag"
                  />
                </div>
              </div>
            </div>
          ) : null
        }
        {
          input.applicant_has_partner ? [
            output.partner_show_income ? (
              <div key="income_partner">
                <h3>Bruto inkomen partner</h3>
                <div className="row">
                  <div className="group col-xs-12">
                    <IncomeInputComponent
                      id="partner_income"
                      onAmountChangeHandler={sync('partner_income')}
                      onPeriodChangeHandler={sync('partner_income_period')}
                      amount={input.partner_income}
                      period={input.partner_income_period}
                      errors={errors.partner_income}
                      label="Bedrag"
                    />
                  </div>
                </div>
                { input.partner_income_period === 'monthly' ?
                  <div className="row">
                    <div className="group col-sm-6 col-xs-12">
                      <CheckboxComponent
                        id="partner_holiday_bonus"
                        onChangeHandler={sync('partner_holiday_bonus')}
                        value={input.partner_holiday_bonus}
                        label="Vakantiegeld?"
                      />
                    </div>
                    <div className="group col-sm-6 col-xs-12">
                      <CheckboxComponent
                        id="partner_13th_month_salary"
                        onChangeHandler={sync('partner_13th_month_salary')}
                        value={input.partner_13th_month_salary}
                        label="13e maand?"
                      />
                    </div>
                  </div> : null
                }
              </div>
            ) : null,
            output.partner_show_aow ? (
              <div key="pension_partner">
                <h3>Pensioeninkomen partner</h3>
                <div className="row">
                  <div className="group col-xs-12">
                    <IncomeInputComponent
                      id="partner_pension_income"
                      onAmountChangeHandler={sync('partner_pension_income')}
                      onPeriodChangeHandler={sync('partner_pension_income_period')}
                      amount={input.partner_pension_income}
                      period={input.partner_pension_income_period}
                      errors={errors.partner_pension_income}
                      label="Bedrag"
                    />
                  </div>
                </div>
              </div>
            ) : null,
          ] : null
        }
        {
          output.partner_show_aow || output.applicant_show_aow ? (
            <MessageBoxComponent closeable={false} open>
              Ga naar {mijnOverheidLink} en log in met uw DigiD om uw pensioen te berekenen.
            </MessageBoxComponent>
          ) : null
        }
      </div>
    </form>
  );
}

WizardIncome.propTypes = {
  sync: PropTypes.func.isRequired,
  forward: PropTypes.func.isRequired,
  recalculating: PropTypes.number,
  input: shapeInput.isRequired,
  output: shapeOutput.isRequired,
};

WizardIncome.defaultProps = {
  recalculating: null,
};

export default connect(state => ({
  recalculating: state.recalculating,
  syncing: state.syncing,
  input: state.input,
  output: state.output,
}), dispatchMapper)(WizardIncome);
